import type { MuxFriendlyFunnelOpts } from "@/config/videoCTAConfig";
import {
  readMuxCtaFriendlyBannerEnv,
  readMuxCtaFreeJoinCopyEnvActive,
} from "@/config/videoCTAConfig";
import type { PremiumInvitePublicConfig } from "@/lib/premiumInvitePublicConfig";

function resolveFriendlyBannerTri(
  admin: boolean | null | undefined,
): "on" | "off" | "unset" {
  if (admin === true) return "on";
  if (admin === false) return "off";
  return readMuxCtaFriendlyBannerEnv();
}

function resolveFreeJoinTri(admin: boolean | null | undefined): boolean {
  if (admin === true) return true;
  if (admin === false) return false;
  return readMuxCtaFreeJoinCopyEnvActive();
}

/** Admin (`mux_cta_*` null = heredar env vars) + env para Mux / Mi VIP. */
export function resolveMuxFriendlyFunnelOpts(
  cfg: PremiumInvitePublicConfig | null | undefined,
): MuxFriendlyFunnelOpts {
  return {
    friendlyBanner: resolveFriendlyBannerTri(cfg?.mux_cta_friendly_banner),
    freeJoinCopy: resolveFreeJoinTri(cfg?.mux_cta_free_join_copy),
  };
}

/** Misma regla que el cartel Mux en embudo premium simple: oculto solo con banner off y sin free-join. */
export function shouldShowPremiumSimpleFriendlySurfaces(
  funnel: MuxFriendlyFunnelOpts,
): boolean {
  return !(funnel.friendlyBanner === "off" && !funnel.freeJoinCopy);
}
